import i18next from 'v2/helpers/i18n';

const contractorsActions = [{ id: 2, text: i18next.t('view-or-edit-app') }];
export default contractorsActions;
